import { getTranslatedProperty } from '@shopware/helpers'
import type { Schemas } from '#shopware'

/**
 * Get the manufacturer name of a product
 * @param product - The product object
 * @returns The translated manufacturer name or null if not available
 */
export function getProductManufacturerName({ product }: { product?: Schemas['Product'] } = {}) {
    if (!product || !product.manufacturer) {
        return null
    }
    return getTranslatedProperty(product.manufacturer, 'name')
}